import React from "react";
import "./Home.css";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

// If image is in public folder:
// const profileImage = "/images/profile.jpg";

// If image is in src/images folder:
import profileImage from "../images/profile.jpg"; // Adjust path as needed

const Home = () => {
  return (
    <section className="home">
      <div className="home-container">
        <div className="home-left">
          <p className="welcome">WELCOME TO MY WORLD</p>
          <h1 className="home-title">
            Hi, I'm <span>Bhanu Prakash</span>
          </h1>
          <h2 className="typing-text">an Engineering Student.</h2>
          <p className="home-description">
            Passionate engineering student with a strong foundation in 
            problem-solving, innovation, and technology. I specialize in 
            building meaningful projects that bridge the gap between theory 
            and real-world applications.
          </p>
          <div className="social-section">
            <h4>FIND WITH ME</h4>
            <div className="social-icons">
              <a href="https://www.facebook.com/kollati.b.prakash/"><FaFacebookF /></a>
              <a href=""><FaInstagram /></a>
              <a href="https://www.linkedin.com/in/bhanu-prakash-kollati-9684a5321/"><FaLinkedinIn /></a>
              <a href="https://github.com/bhanuprakash21624"><FaGithub /></a>
            </div>
          </div>
        </div>
        <div className="home-right">
          <div className="image-card">
            <img
              src={profileImage}
              alt="Bhanu Prakash profile"
            />
          </div>
          <div className="circle one"></div>
          <div className="circle two"></div>
          <div className="circle three"></div>
        </div>
      </div>
    </section>
  );
};

export default Home;